import * as React from 'react';
import { TPAComponentsProvider } from '../components/TPAComponentsConfig';
import { MobileExample } from './MobileExample';
import { setDarkPalette } from './visualTestUtils';

const TIMEOUT_DEFAULT = 5000;

interface AsyncVisualTestWrapperProps {
  isMobile?: boolean;
  isRtl?: boolean;
  onDoneCallback(): void;
  withDarkTheme?: boolean;
  children?: React.ReactNode;
}

export class AsyncVisualTestWrapper extends React.Component<AsyncVisualTestWrapperProps> {
  private _timout: any;

  onDone = async () => {
    const { withDarkTheme, onDoneCallback } = this.props;
    if (withDarkTheme) {
      await setDarkPalette();
    }

    this._timout = setTimeout(() => onDoneCallback(), TIMEOUT_DEFAULT);
  };

  componentDidMount() {
    !this.props.isMobile && this.onDone();
  }

  componentWillUnmount() {
    clearTimeout(this._timout);
  }

  render() {
    const { isMobile, isRtl, children } = this.props;
    return (
      <>
        {isMobile ? (
          <MobileExample isRtl={isRtl} onMobileReady={this.onDone}>
            <div dir={isRtl ? 'rtl' : 'ltr'}>{children}</div>
          </MobileExample>
        ) : (
          <TPAComponentsProvider value={{ mobile: false, rtl: isRtl }}>
            <div dir={isRtl ? 'rtl' : 'ltr'}>{children}</div>
          </TPAComponentsProvider>
        )}
      </>
    );
  }
}
